import { Injectable } from '@angular/core';
import { User } from 'src/app/models/user';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly AUTH_STATUS_KEY = 'mt_auth_status';

  saveToken = () => {
    // Tokens are stored in HttpOnly cookies by the backend
    // We only track auth status in localStorage for app state
    localStorage.setItem(this.AUTH_STATUS_KEY, 'true');
  };

  saveAccessToken = () => {
    // Tokens are stored in HttpOnly cookies by the backend
    localStorage.setItem(this.AUTH_STATUS_KEY, 'true');
  };

  removeToken = () => {
    // Clear local auth status flag
    // HttpOnly cookies are cleared by the backend logout endpoint
    localStorage.removeItem(this.AUTH_STATUS_KEY);
  };

  // Returns true if user appears to be authenticated
  // Note: With HttpOnly cookies, we can't read the actual token value
  isAuthenticated = (): boolean =>
    localStorage.getItem(this.AUTH_STATUS_KEY) === 'true';

  removeFromLocalStorage = (key: string) => {
    localStorage.removeItem(key);
  };

  getStoredUser = (): User | null => {
    const userString = localStorage.getItem('user');
    if (!userString) return null;
    return JSON.parse(userString) as User;
  };

  saveUserLocally = (user: User) => {
    localStorage.setItem('user', JSON.stringify(user));
  };
}
